import { render, staticRenderFns } from "./StockMovementBrowse.vue?vue&type=template&id=5915bc8c&scoped=true"
import script from "./StockMovementBrowse.vue?vue&type=script&lang=ts"
export * from "./StockMovementBrowse.vue?vue&type=script&lang=ts"
import style0 from "./StockMovementBrowse.vue?vue&type=style&index=0&id=5915bc8c&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5915bc8c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5915bc8c')) {
      api.createRecord('5915bc8c', component.options)
    } else {
      api.reload('5915bc8c', component.options)
    }
    module.hot.accept("./StockMovementBrowse.vue?vue&type=template&id=5915bc8c&scoped=true", function () {
      api.rerender('5915bc8c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/stock/StockMovementBrowse.vue"
export default component.exports